import  actionTypes, { GET_ORDER_ASSETS, GET_ASSETS_TYPES, SET_ORDER_ASSET, DELETE_ASSET_ERROR } from './actionTypes';
import api from '../operations/api/api';
import { ApiAddresses } from '../common/apiAddresses';
import { pathOr} from 'ramda';

export const saveAssets = function (id, payload) {
    return dispatch => {
        const url = ApiAddresses.saveAssets(id);
        api()
        .post(url, { assets: payload} )
        .then(response => {
            dispatch({ type: GET_ORDER_ASSETS, payload: response });
        })
        .catch(error => {
            const  err = pathOr(['response', 'data'], error);
            dispatch({type: DELETE_ASSET_ERROR, payload: {error: pathOr("Something went wrong",['response', 'data'], err)} })
        })
    }
};

export const getAssetsType = function() {
    return dispatch => {
        const url = ApiAddresses.getAssetsType;
        api()
        .get(url)
        .then(response => {
            let assets = pathOr([], ['data', 'response'], response);
            assets = assets.map(asset => {
                return { ...asset, value: asset.name }
            })
            dispatch({type: GET_ASSETS_TYPES, payload: assets});
        })
        .catch(error => {
            const  err = pathOr(['response', 'data'], error);
            dispatch({type: DELETE_ASSET_ERROR, payload: {error: pathOr("Something went wrong",['response', 'data'], err)} })
        })
    }
}

export const getOrderAssets = function(id) {
    return dispatch => {
        dispatch({type: actionTypes.SET_ORDER_ASSET_BEGIN});
        const url = ApiAddresses.saveAssets(id);
        api()
        .get(url)
        .then(response => {
            const data = pathOr([], ['data', 'response'], response);
            dispatch({type: SET_ORDER_ASSET, payload: data});
            dispatch({type: actionTypes.SET_ORDER_ASSET_DONE});
        })
        .catch(error => {
            const  err = pathOr(['response', 'data'], error);
            dispatch({type: DELETE_ASSET_ERROR, payload: {error: pathOr("Something went wrong",['response', 'data'], err)} })
        })
    }
}

 export const clearAssetDeleteError = function() {
     return dispatch => {
         dispatch({type: DELETE_ASSET_ERROR, payload: {error: ""}})
     }
 }
